// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const patrat: PokeData = {
  "id": 504,
  "name": "patrat",
  "height": 5,
  "weight": 116,
  "base_experience": 51,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "slam",
    "sand-attack",
    "tackle",
    "leer",
    "bite",
    "hypnosis",
    "focus-energy",
    "bide",
    "hyper-fang",
    "super-fang",
    "detect",
    "mean-look",
    "baton-pass",
    "crunch",
    "nasty-plot",
    "after-you",
    "work-up"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "crunch",
    "splash",
    "purification",
    "growl",
    "protect",
    "scary-face",
    "quick-attack",
    "body-slam",
    "supersonic",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 259,
    "item": null,
    "species": [
      {
        "name": "patrat",
        "order": 505,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "watchog",
        "order": 506,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 504,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42,
    "speed": 42,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
